import { Button, Flex } from '@chakra-ui/react';
import { useEffect } from 'react';

let script: HTMLScriptElement | null;

declare global {
    interface Window {
        zE: any;
        zESettings: any;
    }
}

export const Zendesk = () => {
    const key = 'aa21108f-a28f-4bc8-9518-f715e72e664b';

    const loadZendesk = (key: string, onLoad: EventListenerOrEventListenerObject) => {
        script = document.createElement('script');
        script.async = true;
        script.id = 'ze-snippet';
        script.src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`;
        script.addEventListener('load', onLoad);
        document.body.appendChild(script);
    };

    const onLoad = (e: Event) => {
        if (window.zE) {
            window.zE('webWidget', 'hide');
            window.zE('webWidget:on', 'close', () => {
                window.zE('webWidget', 'hide');
            });
        }
    };

    const onClickHandler = () => {
        if (window.zE) {
            window.zE('webWidget', 'open');
            window.zE('webWidget', 'show');
        }
    };

    useEffect(() => {
        if (!window.zE) {
            loadZendesk(key, onLoad);
        }
        return () => {
            if (script && document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, []);

    return (
        <Flex className="settings-zendesk">
            <Button className="settings-button settings-contact-button" onClick={onClickHandler}>
                Contact Support
            </Button>
        </Flex>
    );
};
